/**
 * Client-side authentication data used by the {@link IAuthenticationClient} during authentication handshake.
 */
var AuthenticationData = /** @class */ (function () {
    function AuthenticationData() {
    }
    return AuthenticationData;
}());
export { AuthenticationData };
//# sourceMappingURL=data.js.map